import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface ReportSectionMetricSelectionDropdownLabelProps {
  selectedMetricLabels: ReadonlyArray<ReactNode>;
}

/*
 * Styles.
 */

const StyledFlexDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledMetricLabelSpan = styled.span`
  ${ellipsis()};
`;

const StyledCounterValueSpan = styled.span`
  font-weight: ${fontWeights.semibold};
  white-space: pre;
`;

/*
 * Component.
 */

export const ReportSectionMetricSelectionDropdownLabel: FC<
  ReportSectionMetricSelectionDropdownLabelProps
> = ({selectedMetricLabels}) => {
  if (selectedMetricLabels.length === 0) {
    return null;
  }

  if (selectedMetricLabels.length === 1) {
    return <StyledMetricLabelSpan>{selectedMetricLabels[0]}</StyledMetricLabelSpan>;
  }

  return (
    <StyledFlexDiv>
      <StyledMetricLabelSpan>{selectedMetricLabels[0]}</StyledMetricLabelSpan>
      <span>,</span>
      <StyledCounterValueSpan> +{selectedMetricLabels.length - 1}</StyledCounterValueSpan>
    </StyledFlexDiv>
  );
};
